
            import {Tooltip} from 'bootstrap';
            // https://getbootstrap.com/docs/5.0/getting-started/javascript/#sanitizer
            const myDefaultWhiteList = Tooltip.Default.allowList
            myDefaultWhiteList.a.push("onclick")
        